import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MensagemUsuario } from '../../models/chat-bot.model';
import { EditFormTable } from 'src/app/shared/models/edit-form.model';
import { ViewFormTable } from 'src/app/shared/models/view-form.model';
import { SuporteLocalService } from '../../services/suporte-local.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';

@Component({
  selector: 'app-suporte-usuario-view',
  templateUrl: './suporte-usuario-view.component.html',
  styleUrls: ['./suporte-usuario-view.component.scss']
})
export class SuporteUsuarioViewComponent extends BaseFormComponent<MensagemUsuario> implements OnInit {
	id:number = 0;
	type:string = '';
	formData: EditFormTable[] | ViewFormTable[] = [
		{ key: 'topico', label: 'Tópico', value: '', type: 'input', class: 'col-12 col-md-8', readonly:true },
		{ key: 'pergunta', label: 'Pergunta', value: '', type: 'textArea', class: 'col-12 col-md-8', readonly:true },
		{ key: 'topico', label: '', value: '', type: 'hr', class: 'col-12 col-md-8', readonly:true },
		{ key: 'nome_usuario_resposta', label: 'Pergunta respondida por', value: '', type: 'input', class: 'col-12 col-md-8', readonly:true },
		{ key: 'resposta_admin', label: 'Resposta', value: '', type: 'textEditor', class: 'col-12 col-md-8 response'},
		];
	data: MensagemUsuario = { } as MensagemUsuario;

	constructor(
		private myService: SuporteLocalService,
		public activatedRoute: ActivatedRoute,
		private navigation: NavigationService,
		private router: Router
	) {
		super(activatedRoute)
	}

	ngOnInit(): void {
		this.loading();
		this.activatedRoute.paramMap.subscribe(params => {
			this.id = +(params?.get('id') ?? 0);
			this.type = params?.get('type') ?? '';
		});
		this.actionLabel = this.type == 'view'? 'Visualizar': (this.type == 'create'? 'Criar':'Editar');
		this.get();
	}

	get():void{
		this.myService.getById(this.id).subscribe({
			next: (response: MensagemUsuario) => { 
				if(!response.visualizado && response.suporte_respondido){
					this.saveViewed();
				}
				else{
					this.loaded();
					this.data = response;
					this.data.respondido = response.suporte_respondido?'Sim':'Não';
					if(!response.suporte_respondido){
						this.formData =  (this.formData as EditFormTable[]).filter(f => f.key != 'nome_usuario_admin_resposta');
					}
				}
			},
			error: (error) => {
				this.loaded();
				this.msgError(error?.error?.message ?? 'Erro ao Buscar dados');
				console.error(error?.error?.error ?? 'Erro ao Buscar dados');
			}
		});
	}

	saveViewed(): void {
		this.myService.update({'visualizado': true}, this.id).subscribe({
			next: (res: MensagemUsuario) => {
				window.location.reload();
			},
			error: (error) => {;
				console.error(error?.error?.error ?? 'Erro ao Salvar');
			},
		})
	}
}



